export const FETCH_FACTORY_DETAIL_REQUEST = 'FETCH_FACTORY_DETAIL_REQUEST';
export const FETCH_FACTORY_DETAIL_SUCCESS = 'FETCH_FACTORY_DETAIL_SUCCESS';
export const FETCH_FACTORY_DETAIL_FAILURE = 'FETCH_FACTORY_DETAIL_FAILURE';


export const FETCH_WAREHOUSE_REQUEST = 'FETCH_WAREHOUSE_REQUEST';
export const FETCH_WAREHOUSE_SUCCESS = 'FETCH_WAREHOUSE_SUCCESS';
export const FETCH_WAREHOUSE_FAILURE = 'FETCH_WAREHOUSE_FAILURE';

export const REJECT_BILL_REQUEST = 'REJECT_BILL_REQUEST';
export const REJECT_BILL_SUCCESS = 'REJECT_BILL_SUCCESS';
export const REJECT_BILL_FAILURE = 'REJECT_BILL_FAILURE';

export const FETCH_WAREHOUSE_DATA_REQUEST = 'FETCH_WAREHOUSE_DATA_REQUEST';
export const FETCH_WAREHOUSE_DATA_SUCCESS = 'FETCH_WAREHOUSE_DATA_SUCCESS';
export const FETCH_WAREHOUSE_DATA_FAILURE = 'FETCH_WAREHOUSE_DATA_FAILURE';

export const FETCH_WAREHOUSE_EDIT_REQUEST = 'FETCH_WAREHOUSE_EDIT_REQUEST';
export const FETCH_WAREHOUSE_EDIT_SUCCESS = 'FETCH_WAREHOUSE_EDIT_SUCCESS';
export const FETCH_WAREHOUSE_EDIT_FAILURE = 'FETCH_WAREHOUSE_EDIT_FAILURE';